import { Button, Col, Row } from "antd";
import React from "react";

// interface FeatureDesc {
//   label: string;
//   desc: string;
//   imageUrl: string;
// }

// const features: FeatureDesc[] = [
//   {
//     label: "Fast endpoint",
//     desc: "Endpoint is included to get your latest data",
//     imageUrl: "image/home/feature/fast-endpoint.svg",
//   },
//   {
//     label: "Custom look",
//     desc: "Change the style of the embed, custom font, spacing, colors, etc.",
//     imageUrl: "image/home/feature/custom-look.svg",
//   },
//   {
//     label: "Payment handling",
//     desc: "Talking to smart contracts is not for everyone, we know.",
//     imageUrl: "image/home/feature/payment-handling.svg",
//   },
//   {
//     label: "Login",
//     desc: "Supporting multiple wallets and seamless logins",
//     imageUrl: "image/home/feature/login.svg",
//   },
//   {
//     label: "Optimized images",
//     desc: "Small images create a faster experience for your users",
//     imageUrl: "image/home/feature/optimize-image.svg",
//   },
//   {
//     label: "Dashboard",
//     desc: "Change the look and feel",
//     imageUrl: "image/home/feature/dashboard.svg",
//   },
// ];

export default function Features() {
  return (
    <Row
      className="feature"
      align={"middle"}
      justify="space-between"
      gutter={[0, 0]}
    >
      <Col xs={24} lg={12} xl={10}>
        <img className="image" src="/image/home/feature/feature.png" alt="" />
      </Col>
      <Col xs={24} lg={12} xl={12}>
        <Row gutter={[0, 48]}>
          <Col xs={24}>
            <Row gutter={[8, 8]}>
              <Col xs={24}>
                <h2 className="color-primary center-when-mobile">
                  Designed for optimal functionality
                </h2>
              </Col>
              <Col xs={24}>
                <p
                  className="w-font-md fw-600 center-when-mobile"
                  style={{ color: "#777E90" }}
                >
                  vIRL Marketplace comes packed with an array of features, and
                  we're continuously working on adding more. The potential for
                  your embed is ever-expanding! Join us on Discord or GitHub to
                  contribute to the conversation about what we should include
                  next.
                </p>
              </Col>
            </Row>
          </Col>
          <Col className="center-when-mobile" xs={24}>
            <Row gutter={[8, 16]} justify="center">
              <Col>
                <a href="/guideline">
                  <Button size="large" type="primary">
                    Show setup guideline
                  </Button>
                </a>
              </Col>
              <Col>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.npmjs.com/package/@waxio/widget-marketplace"
                >
                  <Button style={{ width: "100%" }} type="default" size="large">
                    View NPM Library
                  </Button>
                </a>
              </Col>
              <Col>
                <a
                  target={"_blank"}
                  className="social-icon"
                  rel="noreferrer"
                  href="http://go.wax.io/Discord"
                >
                  <img src="icon/community.svg" alt="" />
                </a>
              </Col>
              <Col>
                <a
                  rel="noreferrer"
                  target={"_blank"}
                  className="social-icon"
                  href="https://github.com/worldwide-asset-exchange/wax-marketplace-widget"
                >
                  <img src="icon/github.svg" alt="" />
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {/* <Col xs={24}>
        <Row gutter={[16, 16]}>
          {features.map((feature) => (
            <Col xs={24} lg={8} xl={8} xxl={4}>
              <Row justify={'center'} className="box-feature" gutter={[0,16]}>
                <Col xs={24}>
                  <Row justify={'center'}><img src={feature.imageUrl} alt={feature.label} /></Row>
                </Col>
                <Col xs={24}>
                  <Row gutter={[0,8]}>
                    <Col xs={24}>
                     <Row justify={'center'}> <h4 className="w-font-md fw-600">{feature.label}</h4></Row>
                    </Col>
                    <Col xs={24}>
                      <p style={{color:'#777E90', textAlign:'center'}} className="w-font-sm fw-600">{feature.desc}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      </Col> */}
    </Row>
  );
}
